import BadRequestHttpError from "../BadRequestHttpError";
import IUserNotFoundHttpErrorResponse from "../../interfaces/BadRequest/IUserNotFoundHttpErrorResponse";

export default class UserNotFoundHttpError extends BadRequestHttpError<IUserNotFoundHttpErrorResponse> {
    constructor(response: IUserNotFoundHttpErrorResponse) {
        super("User not found!", response);
    }
}
